import { useState } from 'react';

// Generators a create touches, shown first; the rest are behind "full config".
const KEY_GENERATORS = [
  'input_classifier',
  'create',
  'custom_activity',
  'slides',
  'sensitive_fallback',
];

function describeReason(reason) {
  if (!reason?.kind) return null;
  if (reason.kind === 'FALLTHROUGH') return 'default rule — you are not individually targeted';
  if (reason.kind === 'TARGET_MATCH') return 'you are individually targeted';
  if (reason.kind === 'RULE_MATCH') return `matched targeting rule #${(reason.ruleIndex ?? 0) + 1}`;
  if (reason.kind === 'OFF') return 'flag is off — serving its off variation';
  return reason.kind.toLowerCase();
}

/**
 * What generator-configuration this environment serves the viewer: environment,
 * variation and why, the key generators, and the full value on expand. Takes the
 * GET /admin/eval/generator-config/serving payload. This is version A of every
 * pairwise comparison started now.
 */
export const ServingGeneratorConfig = ({ serving, error, accent = 'amber' }) => {
  const [showFull, setShowFull] = useState(false);
  const rule = accent === 'amber' ? 'border-amber-200/70' : 'border-gray-200';
  const link = accent === 'amber' ? 'text-amber-700' : 'text-emerald-700';

  if (error) return <p className='text-red-600'>{error}</p>;
  if (!serving) return <p className='text-gray-500'>Loading the served config…</p>;

  const config = serving.value || {};
  const environment = serving.ld_environment?.name || serving.environment_name;
  const reason = describeReason(serving.reason);

  return (
    <div>
      <p>
        <span className='font-medium'>{environment}</span> serves variation{' '}
        <span className='font-medium'>
          &ldquo;{serving.variation_name ?? `#${serving.variation_index}`}&rdquo;
        </span>
        {reason && <span className='text-gray-500'> ({reason})</span>}
      </p>
      <table className='mt-2 w-full text-xs'>
        <tbody>
          {KEY_GENERATORS.filter((key) => config[key]).map((key) => (
            <tr key={key} className={`border-t ${rule}`}>
              <td className='py-1 pr-3 font-mono text-gray-600'>{key}</td>
              <td className='py-1 pr-3 font-mono'>{config[key].model}</td>
              <td className='py-1 pr-3 text-gray-500'>{config[key].reasoning_effort}</td>
              <td className='py-1 text-gray-400'>{config[key].version}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <button
        type='button'
        onClick={() => setShowFull((v) => !v)}
        className={`mt-1 text-xs ${link} hover:underline`}>
        {showFull ? 'Hide full config' : 'Show full config'}
      </button>
      {showFull && (
        <pre className='mt-2 max-h-64 overflow-auto rounded bg-white p-2 text-[11px] leading-snug'>
          {JSON.stringify(config, null, 2)}
        </pre>
      )}
    </div>
  );
};
